import axios from "@/api/axiosInstance";
import { GetProcessWheelsRequest, GetProcessWheelsResponse } from "./types";

export const getProcessWheels = async (
  params?: GetProcessWheelsRequest,
): Promise<GetProcessWheelsResponse> => {
  const response = await axios.get<GetProcessWheelsResponse>(
    "/api/private/admin/process-wheels",
    { params },
  );
  return response.data;
};
